// extracted by css-extract-rspack-plugin
export default {"component":"formatted-input-module__component___WVXIB"};